module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a6f5509545228031a0979c7c0c088b77.png";